<template>
    <div class="language__switcher--wrapper" v-if="langSelected == false">
        <p>Please select a language in which you want to view the module.</p>
        <div class="language__switcher">
            <div class="language__item" v-on:click="changeLangTo('EN', 'EN')">EN</div>
            <div class="language__item" v-on:click="changeLangTo('FR', 'FR')">FR</div>
            <div class="language__item" v-on:click="changeLangTo('DE', 'DE')">DE</div>
            <div class="language__item" v-on:click="changeLangTo('ES', 'ES')">ES</div>
            <div class="language__item" v-on:click="changeLangTo('IT', 'IT')">IT</div>
            <div class="language__item" v-on:click="changeLangTo('RU', 'RU')">RU</div>
            <div class="language__item" v-on:click="changeLangTo('NL', 'NL')">NL</div>
            <div class="language__item" v-on:click="changeLangTo('PL', 'PL')">PL</div>
            <div class="language__item" v-on:click="changeLangTo('PRT', 'PRT')">PRT</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LanguageSwitcher",
        data() {
            return {
                langSelected: false,
                country: String
            }
        },
        created: function () {
            this.$store.watch(
                (state, getters) => getters.user,
                (newValue, oldValue) => {
                    let u = this.$store.getters.user;
                    if (typeof u === 'string' || u instanceof String){
                        u = JSON.parse(u)
                    }
                    this.country = u.user.country;
                    if(this.country != "CX"){
                        this.langSelected = true;
                    }
                    console.log(`Updating from ${oldValue} to ${newValue}`);
                }
            )
        },
        mounted() {
          if( localStorage.getItem("changedLang")){
              this.langSelected = true;
          }
            let u = this.$store.getters.user;
            if (typeof u === 'string' || u instanceof String){
                u = JSON.parse(u)
            }
            this.country = u.user.country;
            console.log(this.country)
            if(this.country != "CX"){
                this.langSelected = true;
            }

        },
        methods:{
            changeLangTo(country, lang){
                localStorage.setItem("changedLang", lang);
                this.$store.dispatch("changeLanguage", {language: lang});
                this.langSelected = true;
            }
        }
    }
</script>

<style scoped>

</style>